import { render, staticRenderFns } from "./cp-details-dialog.vue?vue&type=template&id=20ffbefc&"
import script from "./cp-details-dialog.vue?vue&type=script&lang=js&"
export * from "./cp-details-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports